var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockStatusGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2C3944",
    d: "M8.986.25A7.749 7.749 0 0 0 1.236 8a7.749 7.749 0 0 0 7.75 7.75A7.749 7.749 0 0 0 16.736 8 7.749 7.749 0 0 0 8.986.25ZM15.736 8a6.75 6.75 0 0 1-6.75 6.75A6.75 6.75 0 0 1 2.236 8a6.75 6.75 0 0 1 6.75-6.75A6.75 6.75 0 0 1 15.736 8Zm-4.653 2.76L8.545 8.915a.377.377 0 0 1-.153-.303V3.625c0-.206.169-.375.375-.375h.438c.206 0 .375.169.375.375v4.572L11.783 9.8a.375.375 0 0 1 .081.525l-.256.353a.378.378 0 0 1-.525.081Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.986 0h16v16h-16z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockStatusGrey);
export default __webpack_public_path__ + "static/media/clock-status-grey.88455ba127fb3530b365964622cbd3b2.svg";
export { ForwardRef as ReactComponent };